import React from 'react';
import {navigate} from '@reach/router';
import {ModalBody, Button} from 'reactstrap';
import Modal from 'components/Modal';
import {useModal} from 'contexts/modal';
import classNames from 'classnames';
import FilmOptinForm from 'components/Forms/FilmOptin';

export default function FilmOptinModal({entry = 'default', disableNavigate = false, variant = null, ...props}) {
  const modalProps = useModal();
  const [navigateOnClose, setNavigateOnClose] = React.useState(false);
  const onComplete = React.useCallback(() => {
    modalProps.toggle();
    !disableNavigate && navigate('/masterclass/watch/', {state: {fromEntry: entry}});
  }, []);
  const onStepComplete = React.useCallback((step) => step === 1 && setNavigateOnClose(true), []);
  const toggle = React.useCallback(() => {
    if (navigateOnClose && !disableNavigate) navigate('/masterclass/watch/', {state: {fromEntry: entry}});
    modalProps.toggle();
  }, [navigateOnClose]);
  return (
    <Modal {...props} isOpen={modalProps.isOpen} toggle={toggle} size="lg">
      <ModalBody className="px-4 pt-0 pb-4">
        <h4 className="section-heading text-center mb-3">
          Enter Your Email Now to Watch <br className="d-none d-xl-block" />
          The <i>Fantastic Fungi Special Event Edition</i>
        </h4>
        <p className="text-center mb-4">(And, get our FREE RECIPE GUIDE just for joining us!)</p>
        <FilmOptinForm onComplete={onComplete} id="modalOptInForm" />
      </ModalBody>
    </Modal>
  );
}

export function FilmOptinModalTrigger({children = null, ...props}) {
  const className = classNames('btn-size-350 text-uppercase text-white text-condensed text-800', props.className);
  const modalProps = useModal();
  return (
    <Button color="cta-ff" size="lg" {...props} className={className} onClick={modalProps.toggle}>
      {children ? children : 'Watch for Free Now!'}
    </Button>
  );
}
